import { Serializable } from "../utilities/Serializable";
import { SpecialOfferType } from "./SpecialOfferType";
import { PoS } from "./PoS";
import { CardType } from "./CardType";
import { ProductCategory } from "./ProductCategory";
import { Utils } from "../../providers/paytron-backend/utils";
import { Product } from "./Product";
import { Zone } from "./Zone";

export class SpecialOffer extends Serializable {
    uuid: string;
    description: string;
    value: Number;
    type: SpecialOfferType;
    startDate: string;
    endDate: string;
    pointsOfSale: PoS[];
    zones: Zone[];
    cardTypes: CardType[];
    products: Product[];
    productCategories: ProductCategory[];
    appliesToEveryCardType: boolean;

    constructor() {
        super();
        this.value = 0;
        this.pointsOfSale = [];
        this.zones = [];
        this.cardTypes = [];
        this.productCategories = [];
        this.products = [];
        this.appliesToEveryCardType = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/SpecialOffer.ts